export interface PolyLoaderConfig {
  fill: string;
  fillActive: string;
}

export const POLY_LOADER_CONFIGS: Record<string, PolyLoaderConfig> = {
  greyscale: {
    fill: 'var(--tw-background-disabled-strong)',
    fillActive: 'var(--tw-icon-primary-brand)',
  },
  logo: {
    fill: 'var(--tw-background)',
    fillActive: 'var(--tw-icon-brand)',
  },
};

/** @deprecated Use POLY_LOADER_CONFIGS directly. */
export function getPolyLoaderConfig(): Record<string, PolyLoaderConfig> {
  return POLY_LOADER_CONFIGS;
}
